import { render, staticRenderFns } from "./ProfessionInput.vue?vue&type=template&id=a0feba4a&"
import script from "./ProfessionInput.vue?vue&type=script&lang=ts&"
export * from "./ProfessionInput.vue?vue&type=script&lang=ts&"
import style0 from "./ProfessionInput.vue?vue&type=style&index=0&id=a0feba4a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports